/**
 * Strips an object of all non-allowed properties.
 * TODO Allow functions instead of bools.
 */
module.exports = (obj, allowedProps, allowedVals = {}) => {
  return Object.keys(allowedProps).reduce((accum, key) => {
    if (obj.hasOwnProperty(key)) {
      return { ...accum, [key]: obj[key] }
    }

    return accum;
  }, {});
};
